import PropertyPanel from '../widgets/PropertyPanel.js';

/**
 * VideoPropertyPanel - UI for video material properties
 */
export default class VideoPropertyPanel extends PropertyPanel {
  render(initialData = {}) {
    this.clear();

    // Video URL subsection
    const urlSection = this.builder.createAnimatedSubsection('Video URL', 1, false);
    const urlInput = this.builder.createInput(initialData.url || '', 'text');
    urlInput.placeholder = 'Enter video URL or select preset...';
    urlInput.className = 'gui-input gui-input-full';
    urlInput.addEventListener('input', () => {
      if (this.onChange) this.onChange();
    });
    urlSection.body.appendChild(this.builder.createRow('URL', urlInput, true));
    this.container.appendChild(urlSection.subsection);
    this.controls.urlInput = urlInput;

    // Video presets subsection
    const presetSection = this.builder.createAnimatedSubsection('Presets', 1, false);

    const presets = [
      { value: 'textures/sample-video.webm', label: 'Sample (WebM)', thumbnail: '' },
      { value: 'textures/sample-video.mp4', label: 'Sample (MP4)', thumbnail: '' }
    ];

    const presetSelector = this.builder.createPresetSelector(presets, (preset) => {
      urlInput.value = preset.value;
      if (this.onChange) this.onChange();
    });

    presetSection.body.appendChild(presetSelector.container);
    this.container.appendChild(presetSection.subsection);

    // Autoplay checkbox
    const autoplay = this.addCheckbox('Autoplay', initialData.autoplay !== false);
    autoplay.checkbox.addEventListener('change', () => {
      if (this.onChange) this.onChange();
    });
    this.controls.autoplay = autoplay;

    // Loop checkbox
    const loop = this.addCheckbox('Loop', initialData.loop !== false);
    loop.checkbox.addEventListener('change', () => {
      if (this.onChange) this.onChange();
    });
    this.controls.loop = loop;

    // Muted checkbox
    const muted = this.addCheckbox('Muted', initialData.muted !== false);
    muted.checkbox.addEventListener('change', () => {
      if (this.onChange) this.onChange();
    });
    this.controls.muted = muted;

    // Scale controls
    const scaleSection = this.builder.createAnimatedSubsection('Scale', 1, false);
    const xyzControl = this.builder.createXYZControl(
      (axis, value, isLinked) => {
        if (this.onChange) this.onChange();
      },
      (linked) => {
        if (this.onChange) this.onChange();
      }
    );
    scaleSection.body.appendChild(xyzControl.control);
    this.container.appendChild(scaleSection.subsection);
    this.controls.scaleControl = xyzControl;

    // Offset X control
    const offsetXSlider = this.addSlider('Offset X', -500, 500, 1, initialData.offsetX || 0, (val) => {
      if (this.onChange) this.onChange();
    });
    this.controls.offsetXSlider = offsetXSlider;

    // Offset Y control
    const offsetYSlider = this.addSlider('Offset Y', -500, 500, 1, initialData.offsetY || 0, (val) => {
      if (this.onChange) this.onChange();
    });
    this.controls.offsetYSlider = offsetYSlider;

    // Offset Z control
    const offsetZSlider = this.addSlider('Offset Z', -500, 500, 1, initialData.offsetZ || 0, (val) => {
      if (this.onChange) this.onChange();
    });
    this.controls.offsetZSlider = offsetZSlider;

    // Opacity
    const opacitySlider = this.addSlider('Opacity', 0, 1, 0.01, initialData.opacity || 1, (val) => {
      if (this.onChange) this.onChange();
    });
    this.controls.opacitySlider = opacitySlider;
  }

  getData() {
    return {
      type: 'video',
      url: this.controls.urlInput.value,
      autoplay: this.controls.autoplay.checkbox.checked,
      loop: this.controls.loop.checkbox.checked,
      muted: this.controls.muted.checkbox.checked,
      scaleX: parseFloat(this.controls.scaleControl.controls.x.slider.value),
      scaleY: parseFloat(this.controls.scaleControl.controls.y.slider.value),
      scaleZ: parseFloat(this.controls.scaleControl.controls.z.slider.value),
      offsetX: parseFloat(this.controls.offsetXSlider.slider.value),
      offsetY: parseFloat(this.controls.offsetYSlider.slider.value),
      offsetZ: parseFloat(this.controls.offsetZSlider.slider.value),
      opacity: parseFloat(this.controls.opacitySlider.slider.value)
    };
  }

  setData(data) {
    if (data.url) this.controls.urlInput.value = data.url;
    if (data.autoplay !== undefined) this.controls.autoplay.checkbox.checked = data.autoplay;
    if (data.loop !== undefined) this.controls.loop.checkbox.checked = data.loop;
    if (data.muted !== undefined) this.controls.muted.checkbox.checked = data.muted;
    if (data.scaleX !== undefined) {
      this.controls.scaleControl.controls.x.slider.value = data.scaleX;
      this.controls.scaleControl.controls.x.valueInput.value = data.scaleX;
    }
    if (data.scaleY !== undefined) {
      this.controls.scaleControl.controls.y.slider.value = data.scaleY;
      this.controls.scaleControl.controls.y.valueInput.value = data.scaleY;
    }
    if (data.scaleZ !== undefined) {
      this.controls.scaleControl.controls.z.slider.value = data.scaleZ;
      this.controls.scaleControl.controls.z.valueInput.value = data.scaleZ;
    }
    if (data.offsetX !== undefined) {
      this.controls.offsetXSlider.slider.value = data.offsetX;
      this.controls.offsetXSlider.valueInput.value = data.offsetX;
    }
    if (data.offsetY !== undefined) {
      this.controls.offsetYSlider.slider.value = data.offsetY;
      this.controls.offsetYSlider.valueInput.value = data.offsetY;
    }
    if (data.offsetZ !== undefined) {
      this.controls.offsetZSlider.slider.value = data.offsetZ;
      this.controls.offsetZSlider.valueInput.value = data.offsetZ;
    }
    if (data.opacity !== undefined) {
      this.controls.opacitySlider.slider.value = data.opacity;
      this.controls.opacitySlider.valueInput.value = data.opacity;
    }
  }
}
